export function getDeptId(): string | null {
  try {
    const raw = localStorage.getItem('mgi_user_data')
    if (!raw) return null
    const user = JSON.parse(raw)
    return (
      user?.department_id ||
      user?.department?.id ||
      user?.departmentId ||
      null
    ) ? String(
      user?.department_id || user?.department?.id || user?.departmentId
    ) : null
  } catch {
    return null
  }
}

const ACTIVE_WORKSPACE_KEY = 'mgi_active_workspace_id'

export function getDeptHeaders(): Record<string,string> {
  const id = getDeptId()
  return id ? { 'X-Department-Id': id } : {}
}

export function getActiveWorkspaceId(): string | null {
  try {
    const value = localStorage.getItem(ACTIVE_WORKSPACE_KEY)
    return value && value.trim().length ? value : null
  } catch {
    return null
  }
}

export function setActiveWorkspaceId(id: number | string | null): void {
  try {
    if (id == null || id === '') {
      localStorage.removeItem(ACTIVE_WORKSPACE_KEY)
    } else {
      localStorage.setItem(ACTIVE_WORKSPACE_KEY, String(id))
    }
  } catch {
    // ignore storage errors (private browsing, etc.)
  }
}

export function clearActiveWorkspaceId(): void {
  setActiveWorkspaceId(null)
}

export function getWorkspaceHeaders(): Record<string,string> {
  const workspaceId = getActiveWorkspaceId()
  return workspaceId ? { 'X-Workspace-Id': workspaceId } : {}
}

export function withDept(existing?: Record<string,string>): Record<string,string> {
  return { ...(existing||{}), ...getDeptHeaders() }
}

export function getAuthToken(): string | null {
  try { return localStorage.getItem('mgi_auth_token') } catch { return null }
}

export function getAuthHeaders(): Record<string,string> {
  const token = getAuthToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export function buildStandardHeaders(extra?: Record<string,string>): Record<string,string> {
  return { ...getAuthHeaders(), ...getDeptHeaders(), ...getWorkspaceHeaders(), ...(extra||{}) }
}
